import { Button } from "@mui/material";
import ClientsDataGrid from "./ClientsDataGrid";
import { Link as RouterLink } from "react-router-dom";
import { Add } from "@mui/icons-material";
import useCurrentUser from "hooks/useCurrentUser";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function Clients() {
  const { currentUserPermissions } = useCurrentUser();

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Logistics" }]} />
      <PageTitle>Clients</PageTitle>
      <PageSubtitle>View all the companies that work with Revivn, their locations and contacts.</PageSubtitle>
      <PageActions>
        {currentUserPermissions?.includes("admin") && (
          <Button component={RouterLink} variant="contained" to={`/logistics/clients/new`} startIcon={<Add />}>
            Add New Company
          </Button>
        )}
      </PageActions>

      <ClientsDataGrid />
    </FullPagePaperLayout>
  );
}
